<link
  rel="stylesheet"
  href="https://unpkg.com/ngx-bootstrap/datepicker/bs-datepicker.css"
/>
<div class="animated fadeIn">
  <div class="row d-flex flex-row">
    <div class="col-md-6 align-self-start">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>Copy Files To Storage
        </div>
        <div class="card-body padding-0">
          <div class="row d-flex flex-row">
            <table class="table bare">
              <tr class="bare">
                <td class="bare camCol">
                  <select class="form-select" [(ngModel)]="selectedCam">
                    <option *ngFor="let c of cams" value="{{ c }}">
                      {{ c }}</option
                    >
                  </select>
                </td>
                <td class="bare dateCol fullWidth">
                  <input
                    class="form-control datepickerClass"
                    placeholder="Select date"
                    type="string"
                    [maxDate]="maxDate"
                    #dp="bsDatepicker"
                    bsDatepicker
                    [(ngModel)]="selectedDate"
                    [bsConfig]="{
                      dateInputFormat: 'YYYY-MM-DD',
                      containerClass: 'theme-default',
                      showWeekNumbers: false
                    }"
                  />
                </td>
                <td class="bare dateCol">
                  <button
                    class="float-right btn btn-primary"
                    (click)="addToCopy()"
                  >
                    Add
                  </button>
                </td>
              </tr>
            </table>
          </div>
          <div class="row d-flex flex-row" *ngIf="copyKeys.length > 0">
            <table class="table bare">
              <tr class="bare">
                <th class="camCol bare">Camera</th>
                <th class="dateCol bare">Dates</th>
              </tr>
              <tr class="bare" *ngFor="let c of copyKeys">
                <td class="camCol bare">{{ c }}</td>
                <td class="dateCol bare">{{ copy[c] }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <button class="float-right btn btn-primary" (click)="copyFiles()">
            Copy Files
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-6 align-self-start">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i> Storage Contents
          <button class="float-right btn btn-primary" (click)="deleteStuff()">
            Delete Selected
          </button>
        </div>
        <div class="card-body padding-0">
          <ng-container *ngFor="let c of fStrucArray">
            <table class="table bare">
              <tr class="bare">
                <td class="bareRight">
                  <input
                    type="checkbox"
                    [(ngModel)]="fileStructure[c.host].delete"
                    (change)="toggleDelete()"
                  />
                </td>
                <td class="bareLeft">
                  {{ c.name }}
                  <a
                    [routerLink]="[]"
                    class="nav-link active iconArrow"
                    (click)="toggle(c)"
                    ><i *ngIf="c.expand" class="fa fa-caret-left"></i
                    ><i *ngIf="!c.expand" class="fa fa-caret-down"></i
                  ></a>
                </td>
                <td class="bareLeft"></td>
                <td class="bareLeft"></td>
                <td class="bareLeft lastFill"></td>
              </tr>
              <ng-container *ngIf="c.expand">
                <ng-container *ngFor="let y of c.years">
                  <tr class="bare">
                    <td class="bareLeft"></td>
                    <td class="bareRight">
                      <input
                        type="checkbox"
                        [(ngModel)]="fileStructure[c.host][y.name].delete"
                        (change)="toggleDelete()"
                      />
                    </td>
                    <td class="bareLeft">
                      {{ y.name }}
                      <a
                        [routerLink]="[]"
                        class="nav-link active iconArrow"
                        (click)="toggle(y)"
                        ><i *ngIf="y.expand" class="fa fa-caret-left"></i
                        ><i *ngIf="!y.expand" class="fa fa-caret-down"></i
                      ></a>
                    </td>
                    <td class="bareLeft"></td>
                    <td class="bareLeft lastFill"></td>
                  </tr>
                  <ng-container *ngIf="y.expand">
                    <ng-container *ngFor="let m of y.months">
                      <tr class="bare">
                        <td class="bareLeft"></td>
                        <td class="bareLeft"></td>
                        <td class="bareRight">
                          <input
                            type="checkbox"
                            [(ngModel)]="
                              fileStructure[c.host][y.name][m.name].delete
                            "
                            (change)="toggleDelete()"
                          />
                        </td>
                        <td class="bareLeft">
                          {{ m.name }}
                          <a
                            [routerLink]="[]"
                            class="nav-link active iconArrow"
                            (click)="toggle(m)"
                            ><i *ngIf="m.expand" class="fa fa-caret-left"></i>
                            <i *ngIf="!m.expand" class="fa fa-caret-down"></i
                          ></a>
                        </td>
                        <td class="bareLeft lastFill"></td>
                      </tr>
                      <ng-container *ngIf="m.expand">
                        <ng-container *ngFor="let d of m.days">
                          <tr class="bare">
                            <td class="bareLeft"></td>
                            <td class="bareLeft"></td>
                            <td class="bareLeft"></td>
                            <td class="bareRight">
                              <input
                                type="checkbox"
                                [(ngModel)]="
                                  fileStructure[c.host][y.name][m.name][d]
                                    .delete
                                "
                                (change)="toggleDelete()"
                              />
                            </td>
                            <td class="bareLeft lastFill">
                              {{ d }}
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </table>
          </ng-container>
        </div>
        <div class="card-footer"></div>
      </div>
    </div>
  </div>
</div>
<app-flash-message #fmDialog></app-flash-message>
